import { useQuery, useQueryClient } from "@tanstack/react-query";
import { UserDto } from "dto/user-dto";
import { authService } from "services/authService";

export const useUser = () => {
  const queryClient = useQueryClient();

  const request = useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => {
      console.log("Refetch user");

      return authService.getUserInfo().catch((error) => {
        console.error("Error fetching user info", error);

        return null;
      });
    },
    staleTime: 1000 * 60 * 5,
  });

  const data = request.data ?? authService.getStoredUserInfo();

  const userHasOneOfPermissions = (permissions?: string[]) => {
    if (!permissions || permissions.length === 0) {
      return true;
    }

    if (data == null) {
      return false;
    }

    return permissions.some((item) => data.permissions?.map((p) => p.toString()).includes(item));
  };

  const invalidateUser = (user: UserDto) => {
    queryClient.setQueryData(["auth", "me"], () => user);

    queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
  };

  return {
    user: data ?? authService.getStoredUserInfo(),
    userHasOneOfPermissions,
    invalidateUser,
  };
};
